import { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';

const heroImage = '/images/banner.png?v=1';
const heroImageMobile = '/images/banner-m.jpg?v=1';

export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);


  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        {/* Desktop Image */}
        <img
          src={heroImage}
          alt="一生只为漂"
          className="hidden sm:block w-full h-full object-cover"
        />
        {/* Mobile Image */}
        <img
          src={heroImageMobile}
          alt="民间艺人"
          className="block sm:hidden w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-lake/70 via-deep-lake/50 to-deep-lake/80" />
      </div>
	   
	  
 <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center" style={{ marginTop: '66vh' }}>
          <div
            className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-1000 delay-300 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <a
              href="/products"
              className="inline-flex items-center justify-center px-8 py-4 bg-warm-gold text-deep-lake-dark font-semibold rounded-lg hover:bg-warm-gold-light transition-all duration-300 group"
            >
              探索产品
              <ChevronRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <a
              href="/about"
              className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border border-white/30 hover:bg-white/20 transition-all duration-300"
            >
              了解品牌
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
